require(['jquery', 'assets/js/common/router/index', 'assets/js/modules/browser', 'assets/js/modules/utils'], function(
    $,
    router,
    browser,
    utils
) {
    $(function() {
        var $startPage = $('.start-page');
        var productGroupName = $startPage.data('name');

        var params = productGroupName
            ? { productGroupName: productGroupName, code: browser.getUrlVars().code }
            : { code: browser.getUrlVars().code };

        $.get(router.generate('/start/pricing', params), function(data) {
            if ('typeProducts' in data) {
                data = data.typeProducts.productGroupsBySlugWithCostAndQuantity || [];
            }
            $.each(data, function(slug, groupData) {
                var $productGroupBlock = $('.all-products-group-block-container[data-product-group-slug="' + slug + '"]');
                if ($productGroupBlock.length > 0) {
                    var cost;
                    if (groupData.display_price_per_unit) {
                        cost = groupData.min_cost;
                    } else {
                        cost = groupData.discount_amount > 0 ? groupData.discount_amount : groupData.cost;
                    }

                    $productGroupBlock.find('.all-products-starting-price').text(utils.formatPrice(cost, groupData.currency));
                    $productGroupBlock.find('.all-products-quantity').text(groupData.quantity);
                }
            });
        });
    });
});
